/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj48cGF0aCBkPSJNMy4zMzMzNCAxMEgxNi42NjY3TTE2LjY2NjcgMTBMMTEuNjY2NyA1TTE2LjY2NjcgMTBMMTEuNjY2NyAxNSIgc3Ryb2tlPSIjMTgxRDI3IiBzdHJva2Utd2lkdGg9IjEuNjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";